import React from 'react';

import { Book as BookComponent} from './Book/Book';
import { Book } from '../../../models/books';

import styles from './AddElection.module.scss';

interface SelectedBookProps {
  selectedBook: Book;
}

const SelectedBook = ({ selectedBook }: SelectedBookProps) => {
  if (!selectedBook) return null;

  return (
      <div className={styles.bookSelected}>
      <BookComponent
        style={{ maxHeight: '15rem', maxWidth: '8rem' }}
        book={selectedBook} 
      />
    </div>
  )
}

export default SelectedBook;